import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const PaperSendIcon = ({ className, fill = "#2e2e2e" }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <path
        d="M16.1411 2.95907L7.11109 5.95907C1.04109 7.98907 1.04109 11.2991 7.11109 13.3191L9.79109 14.2091L10.6811 16.8891C12.7011 22.9591 16.0211 22.9591 18.0411 16.8891L21.0511 7.86907C22.3911 3.81907 20.1911 1.60907 16.1411 2.95907ZM16.4611 8.33907L12.6611 12.1591C12.5111 12.3091 12.3211 12.3791 12.1311 12.3791C11.9411 12.3791 11.7511 12.3091 11.6011 12.1591C11.3111 11.8691 11.3111 11.3891 11.6011 11.0991L15.4011 7.27907C15.6911 6.98907 16.1711 6.98907 16.4611 7.27907C16.7511 7.56907 16.7511 8.04907 16.4611 8.33907Z"
        fill={fill}
      />
    </svg>
  );
};

export default PaperSendIcon;
